import comp from "./StudentActivities";

export default comp;
